import { Toaster as Sonner } from "sonner"

type ToasterProps = React.ComponentProps<typeof Sonner>

const Toaster = ({ ...props }: ToasterProps) => {
  // Check if dark mode is active
  const isDark = typeof document !== 'undefined' && document.documentElement.classList.contains('dark')

  return (
    <Sonner
      theme={isDark ? "dark" : "light"}
      className="toaster group"
      position="bottom-right"
      toastOptions={{
        classNames: {
          toast:
            "group toast group-[.toaster]:bg-background group-[.toaster]:text-foreground group-[.toaster]:border-border/30 group-[.toaster]:shadow-sm group-[.toaster]:rounded group-[.toaster]:text-xs group-[.toaster]:py-2 group-[.toaster]:px-3",
          description: "group-[.toast]:text-muted-foreground group-[.toast]:text-[11px]",
          actionButton:
            "group-[.toast]:bg-muted/80 group-[.toast]:text-foreground group-[.toast]:border group-[.toast]:border-border/30 group-[.toast]:rounded group-[.toast]:text-[11px] group-[.toast]:font-medium group-[.toast]:px-2 group-[.toast]:py-0.5 group-[.toast]:hover:bg-muted",
          cancelButton:
            "group-[.toast]:bg-muted group-[.toast]:text-muted-foreground group-[.toast]:rounded group-[.toast]:text-[11px] group-[.toast]:px-2 group-[.toast]:py-0.5",
          success: "group-[.toaster]:border-green-500/20",
          error: "group-[.toaster]:border-red-500/20",
          warning: "group-[.toaster]:border-yellow-500/20",
          info: "group-[.toaster]:border-blue-500/20",
        },
      }}
      {...props}
    />
  )
}

export { Toaster }
